import TimerRegistrationService from '@/shared/services/TimerRegistrationService';
import { useEffect, useState } from 'react';
import eventBus from 'pubsub-js';
export const useGetTimerRegistration = () => {
    const [registration, setRegistration] = useState(TimerRegistrationService.getRunningRegistration());
    useEffect(() => {
        const sub = eventBus.subscribe('timerRegistrationChanged', () => {
            setRegistration(TimerRegistrationService.getRunningRegistration());
        });
        return () => {
            eventBus.unsubscribe(sub);
        };
    }, []);
    return registration;
};
export const useGetRunningTaskId = () => {
    const registration = useGetTimerRegistration();
    return registration === null || registration === void 0 ? void 0 : registration.plannedTaskId;
};
